import { Donuz } from "donuz-js/Donuz";
import Loading from "@/components/Loading.vue";

// @ is an alias to /src
export default {
    name: "points",
    components: {
        Loading
    },
    data() {
        return {
            obj: {},
            points: {},
            loading: true
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        let result = await Donuz.point.getPointsExtract(
            sessionStorage.getItem(btoa("tokenCliente"))
        );
        if (result.status == 200) {
            this.points = result.pontos;
        }
        this.loading = false;
    },
    methods: {}
};